import { render, staticRenderFns } from "./LinkDetailProductiveUnitAction.vue?vue&type=template&id=3584fbd2&scoped=true&"
import script from "./LinkDetailProductiveUnitAction.vue?vue&type=script&lang=js&"
export * from "./LinkDetailProductiveUnitAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584fbd2",
  null
  
)

export default component.exports